<template>
    <div class="login d-flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden position-relative">
        <svg class="login-molecule-bg" aria-hidden="true" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
            <g fill="none" stroke="#F7B424" stroke-width="1.4">
                <line x1="90" y1="120" x2="230" y2="200" />
                <line x1="230" y1="200" x2="230" y2="340" />
                <line x1="970" y1="600" x2="1110" y2="520" />
                <line x1="970" y1="600" x2="970" y2="460" />
            </g>
            <g fill="#F7B424">
                <circle cx="90" cy="120" r="6" />
                <circle cx="230" cy="200" r="7" />
                <circle cx="230" cy="340" r="6" />
                <circle cx="970" cy="600" r="7" />
                <circle cx="1110" cy="520" r="6" />
                <circle cx="970" cy="460" r="6" />
            </g>
            <g fill="none" stroke="#051629" stroke-width="1.5">
                <polygon points="600,60 640,84 640,132 600,156 560,132 560,84" />
                <polygon points="1050,220 1080,238 1080,274 1050,292 1020,274 1020,238" />
                <polygon points="150,560 180,578 180,614 150,632 120,614 120,578" />
            </g>
        </svg>
        <form class="d-flex flex-column align-items-center justify-content-center w-100"  @submit.prevent="login">
            <div class="login_card" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
                <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius: 53px">
                    <div class="text-center mb-5">
                        <img src="@/assets/images/logo_navbar.png" alt="Image" class="logo_navbar my-3" />
                        <div class="text-900 text-3xl font-medium mb-3">مرحبا بك</div>
                        <span class="text-600 font-medium">برجاء تسجيل الدخول</span>
                    </div>

                    <div class="d-flex flex-column">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">المستخدم</label>
                        <InputText id="email1" type="text" placeholder="المستخدم" class="w-100 mb-4" style="padding: 1rem" v-model="phone" />

                        <label for="password1" class="block text-900 font-medium text-xl mb-2">كلمة المرور</label>
                        <Password id="password1" v-model="password" placeholder="كلمة المرور" :feedback="false" class="w-100 mb-4" inputClass="w-full" :inputStyle="{ padding: '1rem', width: '100%' }"></Password>

                    </div>
                    <button type="submit" class="btn loginButton">تسجيل الدخول</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Swal from 'sweetalert2';

export default {
    name: "login-auth",
    data() {
        return {
            phone: "",
            password: "",
        }
    },
    components: {
        InputText,
        Password,
        Button,
        Checkbox
    },
    methods: {
        async login() {
            const formData = new FormData();
            formData.append('phone', this.phone);
            formData.append('password', this.password);
            let response = await this.$store.dispatch("Login", formData);
            // console.log(this.phone.replace(/\s+/g, ''));
            if (this.phone === "" || this.password === "") {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "برجاء التحقق من كل البيانات",
                });
                this.disableButton = false;
            }
            else {
                try {
                    if (response.data.status == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: response.data.message,
                        });
                        this.phone= "",
                        this.password = ""
                        window.location.assign(this.$router.resolve('/').href);
                    }
                    else if(response.data.status == false){
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: response.data.message,
                        });
                    }
                }catch (err) {
                    // console.log(err.response)
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: err.response.data.message,
                    });
                }
            }
        },
    }
}
</script>

<style scoped>
.login-molecule-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    opacity: 0.06;
    z-index: 0;
}
</style>